import { HeadContent, Outlet, useRouterState } from "@tanstack/react-router";

import { AdminConsoleNavbar } from "../components/admin-console-navbar/admin-console-navbar";
import { AppHeader } from "../components/app-header/app-header";
import { NotificationModal } from "../components/notifications-panel/local-components/notification-modal";
import { Devtools } from "./devtools";
import { useAuthAxiosInterceptors } from "../shared/hooks/use-auth-axios-interceptors";

export const AppLayout = () => {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const isAdminConsole = pathname.startsWith("/admin");

  useAuthAxiosInterceptors();

  return (
    <div className="flex min-h-screen min-w-full grow flex-col pt-[var(--app-header-height)]">
      <HeadContent />
      {isAdminConsole ? <AdminConsoleNavbar /> : <AppHeader />}
      <div className="bg-neutrals-99 flex min-h-0 flex-1 flex-col">
        <Outlet />
      </div>
      <NotificationModal />
      <Devtools />
    </div>
  );
};
